/* eslint-disable @typescript-eslint/no-unused-vars */
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FilteredReferentialsIds } from '@scenario/models/filtered-referentials-ids.model';

export interface FilteredReferentialsIdsState {
  filteredReferentialsZoneIds: number[];
  filteredReferentialsSourceIds: number[];
  filteredReferentialsBasecaseIds: number[];
  filteredReferentialsSubtypeIds: number[];
  filteredReferentialsWeatherYearIds: number[];
  filteredReferentialsMarketAreaIds: number[];
  isFetching: boolean;
  error?: string;
}

export const initialState: FilteredReferentialsIdsState = {
  filteredReferentialsZoneIds: [],
  filteredReferentialsSourceIds: [],
  filteredReferentialsBasecaseIds: [],
  filteredReferentialsSubtypeIds: [],
  filteredReferentialsWeatherYearIds: [],
  filteredReferentialsMarketAreaIds: [],
  isFetching: false,
};

export const filteredReferentialsIdsSlice = createSlice({
  name: 'filteredReferentialsIds',
  initialState,
  reducers: {
    retrieveFilteredReferentialsIds: (state, _action: PayloadAction<{inactiveFields: string[], filteredReferentialsIds: FilteredReferentialsIds}>) => {
      state.isFetching = true;
    },
    retrieveFilteredReferentialsIdsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    retrieveFilteredReferentialsZoneIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredReferentialsZoneIds = action.payload;
      state.isFetching = false;
    },
    retrieveFilteredReferentialsSourceIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredReferentialsSourceIds = action.payload;
      state.isFetching = false;
    },
    retrieveFilteredReferentialsBasecaseIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredReferentialsBasecaseIds = action.payload;
      state.isFetching = false;
    },
    retrieveFilteredReferentialsSubtypeIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredReferentialsSubtypeIds = action.payload;
      state.isFetching = false;
    },
    retrieveFilteredReferentialsWeatherYearIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredReferentialsWeatherYearIds = action.payload;
      state.isFetching = false;
    },
    retrieveFilteredReferentialsMarketAreaIdsSuccess: (state, action: PayloadAction<number[]>) => {
      state.filteredReferentialsMarketAreaIds = action.payload;
      state.isFetching = false;
    },
  },
});


export const {
  retrieveFilteredReferentialsIds,
  retrieveFilteredReferentialsIdsFailure,
  retrieveFilteredReferentialsZoneIdsSuccess,
  retrieveFilteredReferentialsSourceIdsSuccess,
  retrieveFilteredReferentialsBasecaseIdsSuccess,
  retrieveFilteredReferentialsSubtypeIdsSuccess,
  retrieveFilteredReferentialsWeatherYearIdsSuccess,
  retrieveFilteredReferentialsMarketAreaIdsSuccess,
} = filteredReferentialsIdsSlice.actions;

export default filteredReferentialsIdsSlice.reducer;
